import * as analytics from '~/src/lib/analytics';
import * as gtm from '~/src/lib/gtm';
import React, { useState, useEffect } from 'react';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import getThemeColor from '~/src/lib/getThemeColor';
import HandlerNotification from '~/src/components/HandlerNotification';
import getCustomButton1 from '~/src/lib/getCustomButton1';
import getCustomRadius from '~/src/lib/getCustomRadius';
import CookieWatcher from '~/src/components/CookieWatcher';
import Header from '../Header';
import Footer from '../Footer';
import Rgpd from '../Rgpd';
import { useScreenDetector } from '~/src/hooks/useScreenDetector';

function App(props) {
    const business = useSelector((state) => state.business);
    const [pathname, setPathname] = useState('');
    const { isMobile, isTablet, isDesktop } = useScreenDetector();

    const router = useRouter();

    useEffect(() => {
        if (Object.keys(business).length > 0) {
            if (
                business.info.ga &&
                typeof business.info.ga &&
                business.info.ga.length > 2
            ) {
                if (pathname !== router.pathname) {
                    setPathname(router.pathname);

                    analytics.initGA(business.info.ga);
                    analytics.logPageView();
                }
            }

            if (
                business.info.gtm &&
                typeof business.info.gtm &&
                business.info.gtm.length > 2
            ) {
                gtm.init(business.info.gtm);
            }
        }
    }, [business]);

    console.log('ROUTE' + router.pathname);

    useEffect(() => {
        const div = document.getElementById('layout');
        if (business.info && business.info.site_max_width) {
            if (div) {
                //https://trello.com/c/mXDygVX9/1579-pages-statiques-appliquer-le-r%C3%A9glage-de-largeur-max-sett%C3%A9-dans-client
                if (
                    router.pathname !== '/m/[slug]' &&
                    router.pathname !== '/'
                ) {
                    div.style.maxWidth = `${business.info.site_max_width}px`;
                    //div.style.maxWidth = '100%';
                } else {
                    div.style.maxWidth = '100%';
                }
            }
        }
    }, [business, router.pathname]);

    if (typeof window !== 'undefined') {
        //window.containerWidth = width;
    }

    if (['/maintenance'].includes(router.pathname)) {
        return props.children;
    }

    return (
        <React.Fragment>
            <NextSeo
                additionalMetaTags={[
                    {
                        name: 'theme-color',
                        content: business ? getThemeColor(business) : '#FFFFFF',
                    },
                ]}
            />
            {<Header />}

            {typeof business === 'object' && business.info && (
                <style type="text/css">
                    {`
                            .MuiInputBase-adornedStart {
                                border-radius: ${getCustomRadius(
                                    business,
                                )}px !important;
                            }
                            .Mui-focused .MuiOutlinedInput-notchedOutline  {
                                border-color: ${getCustomButton1(
                                    business,
                                )} !important;
                            }
                            .MuiFormLabel-root.Mui-focused  {
                                color: ${getCustomButton1(business)} !important;
                            }
                        `}
                </style>
            )}

            <div
                id="layout"
                style={{
                    margin: '0 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: '100vh',
                    //minHeight: 1000,
                    maxWidth: '100%',
                    padding:0,
                 
                }}
                className="layout"
            >
                {props.children}
            </div>
            <Footer />
            <Rgpd />
            <CookieWatcher />
            <HandlerNotification />
        </React.Fragment>
    );
}

export default App;
